import React, { useState, useEffect, useCallback } from 'react';
import { AdminAPI } from '../services/portalApi';

interface AuditEntry {
  id: string;
  admin_id: string | null;
  admin_name: string | null;
  action: string;
  target: string | null;
  admin_ip: string | null;
  created_at: string;
}

export const PortalAuditLog: React.FC = () => {
  const [logs, setLogs] = useState<AuditEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const perPage = 50;

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await AdminAPI.getAuditLogs(page, perPage);
      setLogs(data.items);
      setTotal(data.total);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  const totalPages = Math.ceil(total / perPage);

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>Audit Log</h2>

      <div className="portal-card">
        {loading ? (
          <p style={{ color: 'var(--text-secondary)' }}>Loading...</p>
        ) : logs.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)' }}>No audit entries yet.</p>
        ) : (
          <>
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Admin</th>
                    <th>Action</th>
                    <th>Target</th>
                    <th>IP</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{new Date(log.created_at).toLocaleString()}</td>
                      <td>{log.admin_name || '—'}</td>
                      <td>
                        <span className="portal-badge portal-badge-blue">{log.action}</span>
                      </td>
                      <td style={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {log.target || '—'}
                      </td>
                      <td><code>{log.admin_ip || '—'}</code></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="portal-pagination">
                <button
                  className="portal-btn portal-btn-secondary portal-btn-sm"
                  disabled={page <= 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Previous
                </button>
                <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                  Page {page} of {totalPages} ({total} entries)
                </span>
                <button
                  className="portal-btn portal-btn-secondary portal-btn-sm"
                  disabled={page >= totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
